export default __webpack_public_path__ + "static/media/gn.347b60cf.svg";